import CollapsibleSection from 'components/CollapsibleSection';

import SpraySettingsBody from './components/SpraySettingsBody';
import { APPLICATION_TYPE_SPRAY, SPRAY_TITLE, SPREAD_TITLE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SpraySettingsSection: FunctionComponent<Props> = ({
    className = '',
    isOpen,
    onSpraySettingsChange,
    onToggle,
    spraySettings,
    testId = TEST_ID
}) => {
    const sectionTitle =
        spraySettings.applicationType === APPLICATION_TYPE_SPRAY ? SPRAY_TITLE : SPREAD_TITLE;

    return (
        <CollapsibleSection
            className={`${className} ${styles.spraySettingsSection}`}
            isOpen={isOpen}
            onToggle={onToggle}
            testId={testId}
            title={sectionTitle}>
            <SpraySettingsBody
                onSpraySettingsChange={onSpraySettingsChange}
                spraySettings={spraySettings}
            />
        </CollapsibleSection>
    );
};

export default SpraySettingsSection;
